var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state === true || _vm.state === 'true' || _vm.state == 'yes')?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("mdi-check")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }